import * as React from 'react'
import { withRouter } from 'react-router-dom'
import { observer } from 'mobx-react'
import { Modal, ButtonToolbar, Button } from 'react-bootstrap'
import LocalizationStore from '../../../Stores/LocalizationStore'
import QuestionnairesStore from '../../../Stores/QuestionnairesStore'
import { history } from '../../../Routing'
import {
    getQuestionnairePrefillFormSchema,
    UIQuestionnairePrefillFormSchema,
} from '../../../Model/QuestionnairePrefillForm'
import Form, { ISubmitEvent } from 'react-jsonschema-form'
import HttpActionsService from '../../../Services/HttpActionsService'
import { QuestionnairePrefillData } from '../../../Model/Questionnaire'

interface IQuestionnaireCreateParams {
}

@observer
class QuestionnaireCreate extends React.Component<IQuestionnaireCreateParams> {

    uiSchema: any = UIQuestionnairePrefillFormSchema

    constructor(props: any) {
        super(props)
        this.state = {
            show: false
        }
    }

    qs = QuestionnairesStore.getInstance()

    showModal() {
        this.setState({ show: true })
    }

    handleClose(e: any, context: QuestionnaireCreate) {
        context.setState({ show: false })
    }

    handleOk(e: ISubmitEvent<any>, context: QuestionnaireCreate) {
        if (e.formData['pinPrefill']) {
            HttpActionsService.getInstance()
                .getQuestionnairePrefillDataByPin(
                    new QuestionnairePrefillData(
                        e.formData['pinPrefill'],
                        e.formData['phonePrefill'],
                        e.formData['termCountMonthsPrefill']
                    )
                )
        }
        QuestionnairesStore.getInstance().setPrefillData(
            new QuestionnairePrefillData(
                e.formData['pinPrefill'],
                e.formData['phonePrefill'],
                e.formData['termCountMonthsPrefill']
            )
        )
        context.setState({ show: false })
        history.push('/questionnaire')
    }

    render() {
        const self = this
        const ls = LocalizationStore.getInstance()!

        return (
            <div>
                <Modal
                    show={self.state['show']}
                    onHide={() => { return self.handleClose({}, self) }}
                    animation={false}
                    keyboard={false}
                    backdrop={true}
                >
                    <div className="formWrapper">
                        <Form
                            onSubmit={(e) => { self.handleOk(e, self) }}
                            schema={getQuestionnairePrefillFormSchema()}
                            uiSchema={this.uiSchema}
                        >
                            <ButtonToolbar>
                                <Button
                                    bsStyle="link"
                                    onClick={(e) => { return self.handleClose(e, self) }}
                                >
                                    {ls.t!('Cancel')}
                                </Button>
                                <Button
                                    type="submit"
                                    bsStyle="success"
                                >
                                    {ls.t!('Create')}
                                </Button>
                            </ButtonToolbar>
                        </Form>
                    </div>

                </Modal>
                <Button
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title={ls.t!('Add questionnarie')}
                    className="create-btn"
                    onClick={() => self.showModal()}
                    data-html="true"
                >
                    {ls.t!('Add questionnarie')}
                </Button>
                <Button
                    data-toggle="tooltip"
                    data-placement="bottom"
                    title={ls.t!('Add questionnarie')}
                    className="create-btn closed"
                    onClick={() => self.showModal()}
                    data-html="true"
                >
                    +
                </Button>
            </div>
        )
    }
}

export default withRouter(QuestionnaireCreate)


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/QuestionnaireCreateView.tsx